import React, { useEffect, useState } from 'react';
import { BarChart3 } from 'lucide-react';

const monthLabel = (k) => new Date(`${k}-01T12:00:00`).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
const gbp = (n) => (n ? `£${Number(n).toLocaleString('en-GB')}` : '—');

// Owner dashboard: cancellations per month and deposit money kept / refunded.
export const CancellationReport = ({ authFetch }) => {
  const [d, setD] = useState(null);
  useEffect(() => { authFetch('get', '/admin/cancellation-report?months=6').then(({ data }) => setD(data)).catch(() => setD(null)); }, [authFetch]);
  if (!d) return null;
  const t = d.total;
  return (
    <section className="mb-8 rounded-xl border border-slate-200 bg-white p-4" data-testid="cancellation-report">
      <div className="flex items-center gap-2 mb-1">
        <BarChart3 className="w-4 h-4 text-[color:var(--mv-orange)]" />
        <h2 className="font-display font-black text-[color:var(--mv-navy)]">Cancellations (last 6 months)</h2>
      </div>
      <div className="text-sm text-slate-600 mb-3" data-testid="cancellation-report-total">
        <strong>{t.cancelled}</strong> cancelled · {t.our_fault} by us · {t.customer} by customer · deposits kept <strong className="text-emerald-700">{gbp(t.kept)}</strong> · refunded <strong className="text-red-700">{gbp(t.refunded)}</strong>{t.refund_pending ? <> · still to refund <strong className="text-amber-700">{gbp(t.refund_pending)}</strong></> : null}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-[10px] uppercase tracking-wider text-slate-500 text-left">{['Month', 'Cancelled', 'Our fault', 'Customer', 'Deposit kept', 'Refunded', 'To refund'].map(h => <th key={h} className="p-2">{h}</th>)}</tr></thead>
          <tbody>
            {d.months.map(r => (
              <tr key={r.month} className="border-t border-slate-100" data-testid={`cancel-report-${r.month}`}>
                <td className="p-2 font-bold text-[color:var(--mv-navy)]">{monthLabel(r.month)}</td>
                <td className="p-2">{r.cancelled || '—'}</td>
                <td className="p-2">{r.our_fault || '—'}</td>
                <td className="p-2">{r.customer || '—'}</td>
                <td className="p-2 text-emerald-700 font-bold">{gbp(r.kept)}</td>
                <td className="p-2 text-red-700 font-bold">{gbp(r.refunded)}</td>
                <td className="p-2 text-amber-700 font-bold">{gbp(r.refund_pending)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-[11px] text-slate-400 mt-2">Deposit amounts are only tracked for bookings cancelled with the new Cancel button. Older cancellations are counted but have no deposit figure.</p>
    </section>
  );
};
